export default __webpack_public_path__ + "static/media/retirement-sum-scheme-mobile.61856c1e.svg";